import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitReservation = (data) => api.post("/reservations", data).then((r) => r.data);
export const submitOrder = (data) => api.post("/orders", data).then((r) => r.data);
export const submitEventBooking = (data) => api.post("/events/booking", data).then((r) => r.data);
export const submitCatering = (data) => api.post("/catering", data).then((r) => r.data);
export const submitFranchise = (data) => api.post("/franchise", data).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);

// Streaming chat via fetch (text stream)
export async function streamChat(sessionId, message, onDelta) {
  const res = await fetch(`${API}/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message }),
  });
  if (!res.body) {
    const text = await res.text();
    onDelta(text);
    return;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    onDelta(decoder.decode(value, { stream: true }));
  }
}
